import { SpinnerThemes } from '@usitsdasdesign/dds-ng/shared';
import { SpinnerComponent } from '@usitsdasdesign/dds-ng/spinner';

import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, contentChild, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { LoadingService } from '@services/loading.service';

@Component({
  selector: 'app-loading',
  imports: [SpinnerComponent, NgTemplateOutlet],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
  public size = input('40px');
  public thickness = input('4px');
  public customClass = input<string>('');
  public theme = input<SpinnerThemes | string>(SpinnerThemes.dark);
  public isInverse = input(false);

  public bdColor = input<string>('');
  public fullscreen = input(false);
  public zIndex = input(1000);

  protected customLoading = contentChild<TemplateRef<unknown>>('loading');

  protected loading = toSignal(inject(LoadingService).loading$(), { initialValue: false });
}
